<template>
  <custom-callout
    class-main="mt-3 rounded"
    :controlled="true"
    :opened="value.isOpen"
    @click:open="onOpenClose"
    :border-color="getRelatedServiceStatusColor(value.status.id)"
  >
    <div class="row py-2 mr-md-0 align-items-center">
      <div class="col-12 col-md-3 pl-md-0 py-2 border-right
                  border-right--variant d-flex justify-content-center
                  justify-content-md-start">

        <div class="col-12 col-md mt-3 mt-md-0">
          <div class="data-title d-block">
            <custom-balloon
              :text="value.status.name"
              :background-color="getRelatedServiceStatusColor(value.status.id)"
              />
          </div>
          <div style="text-align: center;">
            {{ stipulationDesc | empty }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-7 row mx-0">
        <div class="col-12 col-md mt-3 mt-md-0">
          <span class="data-title d-block">Año Academico:</span>
          {{ value.academicYearDescription | empty }}
        </div>
        <div v-if="showService" class="col-12 col-md mt-3 mt-md-0">
          <span class="data-title d-block">Servicio:</span>
          {{ value.serviceName + ' - ' + value.disciplineName| empty }}
        </div>
        <div class="col-12 col-md mt-3 mt-md-0">
          <span class="data-title d-block">Nombre del Estudiante:</span>
          {{ value.studentName | empty }}
        </div>
        <div class="col-12 col-md mt-3 mt-md-0">
          <span class="data-title d-block">SIE:</span>
          {{ value.studentSieId | empty }}
        </div>
        <div v-if="!showService" class="col-12 col-md mt-3 mt-md-0">
        </div>
      </div>
      <div class="col-12 col-md-2 mt-3 mt-md-0 text-right">
        <drop-down :items="actionItems"/>
      </div>
    </div>
    <template #edition>
      <div>
        <additional-information
          v-if="isAdditionalInfo"
          :manage-info-title="
            value.complianceStatusReasonId ? 'Exclusión' : 'Cumplimiento'
          "
          :has-exclude-info="hasExludeInfo"
          :data="value"
          :enums="{ stipulationTypes, complianceStates }"
        />
        <manage-information
          v-if="isManageInfoAccomplish || isManageInfoExclude || isManageDeny "
          :has-reason="isManageInfoExclude"
          :title="manageInformationTitle"
          :reasons="statusReasons"
          :service-view-type-id="viewType"
          :stipulationType="value.stipulationId"
          @on-close="onOpenClose"
          @on-save-manage-information="onSaveManageInformation(value, $event)"
        />
        <management
          v-if="isManagement"
          :id="value.id"
          :student-sie-id="value.studentSieId"
          :management-types="managementTypes"
          :stipulationType="value.stipulationId"
          @on-close="onOpenClose"
        />
        <management-result v-if="isHistory" :id="value.id" :stipulationType="value.stipulationId" ref="managementResult" />
      </div>
    </template>
  </custom-callout>
</template>
<script>
import CustomCallout from "custom-callout";
import DropDown from "dropdown";
import CustomBalloon from "custom-balloon";
import AdditionalInformation from "./AdditionalInformation.vue";
import ManageInformation from "./ManageInformation";
import Management from "./Management";
import ManagementResult from './ManagementResult';
import {
  relatedServiceViewTypes,
  getRelatedServiceStatusColor,
  stipulationTypes,
  complianceStates,
  relatedServiceStatus
} from "@/utils/constants/pei/compliance-rlv/relatedServiceStatus.js";
import rlvService from "@/utils/constants/pei/compliance-rlv/rlvService.js";
import commentTypes from "@/utils/constants/comment/commentTypes";

export default {
  name: "ResultRow",
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
    ManagementResult,
    AdditionalInformation,
    ManageInformation,
    Management
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    managementTypes: {
      type: Array,
      default: () => []
    },
    statusReasons: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    getRelatedServiceStatusColor,
    isOpen: false,
    viewType: relatedServiceViewTypes.AdditionalInfo,
    stipulationTypes,
    complianceStates,
  }),
  computed: {
    actionItems() {
      return [
        {
          label: "Gestiones",
          icon: "fas fa-file-search color-green",
          border: this.value.stipulationActions.canComplyExclude
            ? "bottom"
            : "" || this.value.stipulationActions.canApproveDeny
            ? "bottom"
            : "",
          click: () => this.onOpenManagement()
        },
        {
          label: "Historial Gestiones",
          icon: "fas fa-history color-green",
          visible: this.value.hasHistory,
          border: this.value.stipulationActions.canComplyExclude
            ? "bottom"
            : "" || this.value.stipulationActions.canApproveDeny
            ? "bottom"
            : "",
            click:() => this.openHistory()
        },
        {
          label: "Cumplir",
          icon: "fas fa-check-circle color-green",
          border: "bottom",
          visible: this.value.stipulationActions.canComplyExclude,
          click: () => this.onOpenAccomplish()
        },
        {
          label: "Excluir",
          icon: "fas fa-times-circle color-red",
          visible: this.value.stipulationActions.canComplyExclude,
          click: () => this.onOpenExclude()
        },
        {
          label: "Aprobar",
          icon: "fas fa-check-circle color-green",
          border: "bottom",
          visible: this.value.stipulationActions.canApproveDeny,
          click: () => this.onSaveManageInformation(this.value)
        },
        {
          label: "Comentario",
          icon: "fas fa-file-alt text-green",
          border: "bottom",
          visible: !!this.value.studentSieId,
          click: () => this.$router.push({
            path: `/student/comments/commentshistory/${this.value.studentSieId}/${commentTypes.CumplimientoServiciosEstudianteRLV}`
          })
        },
        {
          label: "Denegar",
          icon: "fas fa-times-circle color-red",
          visible: this.value.stipulationActions.canApproveDeny,
          click: () => this.onOpenDenied()
        },        
        {
          visible: this.canShowChangePendingApproval,
          name: "Pendiente Aprobación",
          icon: "fa fa-undo text-green",          
          click: () => this.onPendingApprovalChangeStatusHandler()
        },
      ];
    },
    showService() {
      return this.value.stipulationId === stipulationTypes.St40
    },
    isOpenPanel() {
      return this.isOpen;
    },
    manageInformationTitle() {
      return this.viewType == relatedServiceViewTypes.ManageInfoAccomplish
        ? "Información de Cumplimiento"
        : "Información de Exclusión" ||
          this.viewType == relatedServiceViewTypes.Deny
        ? "Razón de denegación"
        : "";
    },
    isAdditionalInfo() {
      return this.viewType === relatedServiceViewTypes.AdditionalInfo;
    },
    isManageInfoAccomplish() {
      return this.viewType === relatedServiceViewTypes.ManageInfoAccomplish;
    },
    isManageInfoExclude() {
      return this.viewType === relatedServiceViewTypes.ManageInfoExclude;
    },
    isManageDeny() {
      return this.viewType === relatedServiceViewTypes.Deny;
    },
    isManagement() {
      return this.viewType === relatedServiceViewTypes.Management;
    },
    isHistory() {
      return this.viewType === relatedServiceViewTypes.History;
    },
    hasExludeInfo() {
      return this.value.complianceStatusReasonId;
    },
    stipulationDesc()
    {
      if(this.value.stipulationId === stipulationTypes.St40)
      {
        return "Estipulación 40";
      }
      if(this.value.stipulationId === stipulationTypes.St85)
      {
        return "Estipulación 85";
      }
      if(this.value.stipulationId === stipulationTypes.St86)
      {
        return "Estipulación 86";
      }
    },
    canShowChangePendingApproval(){
      const validStatus = [relatedServiceStatus.Compliment, relatedServiceStatus.Excluded];

      const validServices = [
        rlvService.PORTEADOR_EDU,
        rlvService.PORTEADOR_TER,
        rlvService.REGULAR,
        rlvService.INT,
        rlvService.IDENT_TEMPRANA,
        rlvService.CONSEJERIA_REAH,
        rlvService.ORIE_Y_MOVILIDAD,
        rlvService.MEDICOS,
        rlvService.ENFERMERIA,
        rlvService.TS,
        rlvService.PARENT_TRAINING,
        rlvService.T1
      ];

      return this.value.stipulationId === stipulationTypes.St40 &&
         validStatus.includes(this.value.status?.id) && 
         validServices.includes(this.value.idDisc) && 
        this.userHasPermissions(
            "academic.rlv.changetopendingapprovalstipulation40"
          ) ;
    }
  },
  methods: {
    onSaveManageInformation(value, event) {
      this.onOpenClose();
      this.$emit("on-save-manage-information", value, event);
    },
    onOpenClose() {
      this.viewType = relatedServiceViewTypes.AdditionalInfo;
      this.value.isOpen = !this.value.isOpen;
    },
    onOpenAccomplish() {
      this.viewType = relatedServiceViewTypes.ManageInfoAccomplish;
      this.value.isOpen= true;
    },
    onOpenExclude() {
      this.viewType = relatedServiceViewTypes.ManageInfoExclude;
      this.value.isOpen = true;
    },
    onOpenDenied() {
      this.viewType = relatedServiceViewTypes.Deny;
      this.value.isOpen = true;
    },
    onOpenManagement() {
      this.viewType = relatedServiceViewTypes.Management;
      this.value.isOpen= true;
    },
    openHistory(){
      this.viewType = relatedServiceViewTypes.History;
      this.value.isOpen= true;
    },
    onPendingApprovalChangeStatusHandler(){
        this.$emit("on-pending-approval-change-status", this.value);
    }
  }
};
</script>
<style scoped>
    #dropdownMenuButton{
      background-color: #f7f7f7;
    }
</style>
